import constants from "../../core/constants";
import { toObject } from "../../core/utils";
import isNil from "lodash/fp/isNil";
import flow from "lodash/fp/flow";
import identity from "lodash/fp/identity";
import moment from "moment";

class CorporateHolidayPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (item) => {
      item = angular.copy(item);
      item.date = moment(item.date).format(constants.dateFormat);

      let holidaySchedulesCount = 0;
      if (!isNil(item.schedules)) {
        item.schedules.map((schedule) => {
          schedule.time = moment
            .utc(schedule.time)
            .format(constants.timeFormat);
          if (!isNil(schedule.route)) {
            schedule.districts = schedule.route.name.split("-");
          }
          return schedule;
        });
        item.holidaySchedules = item.schedules.filter((schedules) => {
          if (schedules.selected) holidaySchedulesCount++;
          return holidaySchedulesCount;
        });
      }
      item.holidaySchedules = holidaySchedulesCount;
      item.totalSchedules = item.schedules.length;

      item.holidaySchedules === item.totalSchedules
        ? (item.schedules.selectedAll = true)
        : (item.schedules.selectedAll = false);
      return item;
    };
    return toObject(flow([format, identity])(data));
  }
}

export default CorporateHolidayPageTransform;



// WEBPACK FOOTER //
// ./src/pages/corporateHoliday/corporateHoliday.transforms.js